import { combineReducers } from 'redux';
import SidePanReducer from './SidePanReducer';
import ShipEquipmentReducer from './ShipEquipmentReducer';
import MMPLDashboardReducer from './MMPLDashboardReducer';
import ContractMgmtReducer from './ContractMgmtReducer';
import ServiceUpdateReducer from './ServiceUpdateReducer';
import MasterScreenReducer from './MasterScreenReducer';
import lookupReducer from './lookupReducer';
import UserManagerReducer from "./UserManagerReducer";
import PageLoaderReducer from "./PageLoaderReducer";
import ShipNotesReducer from "./ShipNotesReducer";
import ControlledDocReducer from "./ControlledDocReducer";
import ApproverScreenReducer from './ApproverScreenReducer';
import VendorManagementReducer from './VendorManagementReducer';

const rootReducer = combineReducers({
    SidePanReducer,
    ShipEquipmentReducer,
    MMPLDashboardReducer,
    ContractMgmtReducer,
    ServiceUpdateReducer,
    MasterScreenReducer,
    lookupReducer,
    UserManagerReducer,
    PageLoaderReducer,
    ShipNotesReducer,
    ControlledDocReducer,
    ApproverScreenReducer,
    VendorManagementReducer
});
export default rootReducer;